import {
  DashboardFinancialDropdown,
  DashboardFinancialLink,
  Table,
} from 'bd-web-components'
import { LoaderBox } from './styles'
import Loader from '../Loader'

interface DropdownContainerProps {
  valueTotalFormated: string
  mainData: any
  open: boolean
  loading: boolean
  isBlank: boolean
  columns: any
  dropdownTitle: string
  dropdownSubtitle: string
  linkHref?: string
  linkText?: string
  color: string
}

export const DropdownContainer = ({
  valueTotalFormated,
  open,
  mainData,
  loading,
  columns,
  color,
  dropdownTitle,
  dropdownSubtitle,
  linkHref,
  linkText,
  isBlank,
}: DropdownContainerProps) => {
  return (
    <DashboardFinancialDropdown
      title={dropdownTitle}
      subtitle={dropdownSubtitle}
      value={valueTotalFormated}
      open={open}
      color={color}
    >
      {mainData && (
        <>
          <Table columns={columns} data={mainData} pageCount={0} />
          <DashboardFinancialLink
            text={linkText as string}
            href={linkHref as string}
            isBlank={isBlank as boolean}
          />
        </>
      )}
      {loading && (
        <LoaderBox>
          <Loader noMargin={true} />
        </LoaderBox>
      )}
    </DashboardFinancialDropdown>
  )
}
